export default __webpack_public_path__ + "static/media/hear2.b7bbde8b.svg";